export default __webpack_public_path__ + "static/media/check_step.54f90e98.svg";